import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { useRecoilState } from 'recoil';
import axios from 'axios';

import Login from './main_components/Login';
import Home from './main_components/Home';
import loginStateAtom from './atoms/loginStateAtom';
import { url } from './utils/config';
import myInfoAtom from './atoms/myInfoAtom';
import uiConfigAtom from './atoms/uiConfigAtom';

function App() {

  const [ loggedIn ] = useRecoilState(loginStateAtom);
  const [ uiConfig, setUiConfig ] = useRecoilState(uiConfigAtom);

  useEffect(() => {
    getUiConfig()
  }, [])

  

  async function getUiConfig() {
    try {
      const reqUrl = url + '/ui_config';
      const { data } = await axios.get(reqUrl);
      console.log(JSON.parse(data.data.config))
      setUiConfig(JSON.parse(data.data.config))
    } catch (error) {
      console.log(error)
    }
  }

  return (
      <div>
        <ToastContainer autoClose={false} />
        <Routes>
          <Route path='/login' element={ !loggedIn ? <Login /> : <Navigate to='/' /> }  />
          <Route path='/*' element={ loggedIn ? <Home /> : <Navigate to='/login' /> } />
        </Routes>
      </div>
  );
}

export default App;
